import { render, staticRenderFns } from "./FraudActivities.vue?vue&type=template&id=0f70cadd&"
import script from "./FraudActivities.vue?vue&type=script&lang=js&"
export * from "./FraudActivities.vue?vue&type=script&lang=js&"
import style0 from "./FraudActivities.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports